var _defs, _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130.240478515625px",
    height: "242px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "184.8797607421875 -46 130.240478515625 242",
    style: {
      background: "rgba(0, 0, 0, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing-gradow-gradient",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6600ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "editing-gradow-filter",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceAlpha",
    in: "flood",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4,
    in: "SourceGraphic",
    result: "offset-1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4,
    in: "shadow",
    result: "offset-2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "offset-1"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-gradow-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.98997509479523, 121.19999885559082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.08-74.20L66.08-74.20L66.08-74.20Q54.74-74.20 46.48-77.98L46.48-77.98L42.00-55.30L69.02-55.30L69.02-55.30Q69.02-47.88 65.31-43.19L65.31-43.19L65.31-43.19Q61.60-38.50 54.88-38.50L54.88-38.50L54.88-38.50Q47.60-38.50 40.88-41.16L40.88-41.16L40.88-41.16Q39.48-41.72 39.34-41.86L39.34-41.86L31.36 0L0.84 0L18.62-92.40L81.06-92.40L81.06-92.40Q81.06-83.86 77.07-79.03L77.07-79.03L77.07-79.03Q73.08-74.20 66.08-74.20Z",
    fill: "url(#editing-gradow-gradient)"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text {\n  font-size: 64px;\n  font-family: Arial Black;\n  dominant-baseline: central;\n  text-anchor: middle;\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/F.92626f99105ab42e4eabd68c3e7c90d3.svg";
export { ForwardRef as ReactComponent };